export enum ActionTypes {
  SAVE_COMPANY_REGISTRATION = "SAVE_COMPANY_REGISTRATION",
  SAVE_STUDENT_REGISTRATION = "SAVE_STUDENT_REGISTRATION",
  SEND_REGISTRATION_CONTACT_FORM = "SAVE_REGISTRATION_CONTACT_FORM",
  VERIFY_ACCOUNT_WITH_TOKEN = "VERIFY_ACCOUNT_WITH_TOKEN",
}
